export default "__VITE_ASSET__BdMwoWTm__"